/* Numero pagina corrente
0 | ... | N
*/
import { createContext } from "react";
const CurrentPageContext = createContext({
    currentPage: 0,
    setCurrentPage: (page) => {}
  });
export default CurrentPageContext;